import { useQuery } from "@tanstack/react-query";
import { listSetCategory } from "@api/products";

export const useCategoryListQuery = () => {
  const division =
    typeof window !== "undefined"
      ? localStorage.getItem("categoryType") || "S"
      : "S";

  return useQuery({
    queryKey: ["categoryList", division],
    queryFn: async () => {
      const body = { modes: "ListSet", division };
      const res = await listSetCategory(body);

      if (res?.code === "0000") {
        return res.data || [];
      } else {
        throw new Error(res?.Msg || "카테고리 데이터를 불러올 수 없습니다.");
      }
    },
    enabled: typeof window !== "undefined",
  });
};
